import React from "react";
import EshopItem from "./components/eshopItem";
import Expandable from "./components/expandable";
import Ig1 from "./components/ig1/ig1";
import Reddit from "./components/reddit";
import X1 from "./components/x1";
import MusicPlayer from "./components/musicPlayer";
import HighlightOverlay from "./components/highlightOverlay";
import Head from "./components/Head";
import SEO from "../seo";
import NotificationApp from "./components/NotificationApp";

const Portfolio = () => {
  return (
    <div>
      <SEO
        title="Developer's Portolio"
        description="My personal portfolio. I code random stuff to prove that I know something."
      />
      <Head />
      <div className="p-10 xl:p-20">
        <Ig1 />
        <Reddit />
        <EshopItem />
        <X1 />
        <Expandable />
        <MusicPlayer />
        <HighlightOverlay />
        <NotificationApp />
      </div>
    </div>
  );
};

export default Portfolio;
